export default __webpack_public_path__ + "static/media/step6LightMode.49ad9a84.svg";